import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility } from '../utilities';
import { CommonConstant } from '../constants';

@Pipe({ name: 'displayDate' })
export class DisplayDatePipe implements PipeTransform {
    transform(date: any) {
        return date ? DateUtility.dateToString(date, CommonConstant.appDateFormat) : '';
    }
}